<template>
  <div class="flex flex-grow bg-white w-full">
    <span class="name w-1/4">
      <input
        ref="name" v-model="name" v-autowidth="{maxWidth: '250px', minWidth: '20px', comfortZone: 0}"
        @blur="onInputChange"
      />
    </span>
    <el-menu :default-active="activeIndex" class="w-3/4" mode="horizontal">
      <el-menu-item index="1" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.dash.edit', [app_id, dash_id])">图表设计</Link>
      </el-menu-item>
      <el-menu-item index="3" class="flex items-stretch">
        <Link class="flex-1 px-5" :href="zroute('app.dash.publish', [app_id, dash_id])">图表发布</Link>
      </el-menu-item>
    </el-menu>
  </div>
</template>
<script>
import VueInputAutowidth from 'vue-input-autowidth'
import zroute from '../ziggy'
import {Link} from '@inertiajs/inertia-vue'
import axios from 'axios'

export default {
  components: {
    Link,
  },
  directives: {
    autowidth: VueInputAutowidth,
  },
  props: {
    activeIndex: {
      type: String,
      default: '1',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      dash_id: zroute().params.dash_id,
      name: this.value,
    }
  },
  methods: {
    onInputChange() {
      axios.post(zroute('app.form.rename', {app_id: this.app_id, form_id: this.dash_id}), {
        name: this.name,
      }).then(res => {
        console.log(res)
      })

    },
  },
}
</script>
<style lang="scss" scoped>
.name {

  input {
    font-size: 16px;
    margin: 5px 0;
    padding: 0 2px;
    height: 30px;
    color: #1F2D3D;
    border: 0;
    border-bottom: dashed 1px #333;
    background-color: transparent;
  }
}
.el-menu, .el-menu-item {
  height: 42px;
  line-height: 42px;
  padding: 0;
}
.el-menu.el-menu--horizontal {
  border: 0;
}
</style>
